import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconTrendingUp = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "m10 10.414 4 4 5.707-5.707L22 11V5h-6l2.293 2.293L14 11.586l-4-4-7.707 7.707 1.414 1.414z" }) }));
const Memo = memo(SvgIconTrendingUp);
export default Memo;
//# sourceMappingURL=IconTrendingUp.js.map